import { defineStore } from 'pinia'

const STORE_NAME = 'user'

// Note that this storage is set up as sessionStorage
export const useUserStore = defineStore(STORE_NAME, {
  state: () => ({
    user: {},
  }),
  getters: {
    getUser: (state) => state.user,
    hasUser: (state) => !!state.user?.id,
  },
  actions: {
    reset() {
      this.user = {}
    },
    updateUser(user) {
      this.user = { ...this.user, ...user }
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
    key: `db-${STORE_NAME}`,
  },
})
